// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","wrapper":"Header_wrapper__r1+ms"};